import React from 'react';
import { FiArrowUpRight, FiTrendingUp } from 'react-icons/fi';

function MetricCard({ label, value, sublabel, onClick, active, accent = 'zinc', trend, hint }) {
  const accentClasses = {
    zinc: 'text-zinc-900',
    indigo: 'text-indigo-700',
    emerald: 'text-emerald-700',
    amber: 'text-amber-700',
    sky: 'text-sky-700',
  };
  return (
    <button
      type="button"
      onClick={onClick}
      title={hint || ''}
      className={`group relative flex h-[92px] w-full flex-col justify-between rounded-xl border bg-white px-3 py-2.5 text-left transition ${
        active
          ? 'border-zinc-900 shadow-sm'
          : 'border-zinc-200 hover:border-zinc-300 hover:shadow-sm'
      }`}
    >
      <div className="flex items-center justify-between gap-1">
        <span className="text-[10px] font-semibold uppercase tracking-wider text-zinc-500">
          {label}
        </span>
        <FiArrowUpRight className="h-3 w-3 text-zinc-300 transition group-hover:text-zinc-500" />
      </div>
      <div>
        <div className={`text-xl font-semibold tabular-nums tracking-tight ${accentClasses[accent]}`}>
          {value}
        </div>
        {sublabel ? (
          <div className="mt-0.5 flex items-center gap-1 text-[11px] text-zinc-500">
            {trend === 'up' ? <FiTrendingUp className="h-3 w-3 text-emerald-500" /> : null}
            <span className="truncate">{sublabel}</span>
          </div>
        ) : null}
      </div>
    </button>
  );
}

export default function KpiStrip({ metrics, activeId, onSelect }) {
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-7">
      {metrics.map((m) => (
        <MetricCard
          key={m.id}
          label={m.label}
          value={m.value}
          sublabel={m.sublabel}
          accent={m.accent}
          trend={m.trend}
          hint={m.hint}
          active={activeId === m.id}
          onClick={() => onSelect?.(m)}
        />
      ))}
    </div>
  );
}
